export function fromGraphql(data) {
    var locales = {};
    if (!data) {
        return locales;
    }
    data.forEach(function (row) {
        locales[row.lng] || (locales[row.lng] = {});
        locales[row.lng][row.name] || (locales[row.lng][row.name] = {});
        row.translations.forEach(function (translation) {
            locales[row.lng][row.name][translation.key] = translation.value;
        });
    });
    return locales;
}
